import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SMS_SENDERS } from '@models/menu-entries';
import { ApiGetPageOptions } from '@models/pages/page';
import { SmsSender } from '@models/sms/sender';
import { SmsTemplate } from '@models/sms/templates';
import { SmsAdv } from '@models/smsadv/smsadv';
import { LandingPageModalComponent } from '@modules/sms/components/landing-page-modal/landing-page-modal.component';
import { SmsTextareaComponent } from '@modules/sms/components/sms-textarea/sms-textarea.component';
import { SmsTemplateCreateEditModalComponent } from '@modules/sms/templates/create-edit-modal/sms-template-create-edit-modal.component';
import { InsertTemplateModalComponent } from '@modules/sms/templates/insert-tamplate-modal/insert-tamplate-modal.component';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { MenuService } from '@services/menu.service';
import { PagesService } from '@services/pages.service';
import { SenderService } from '@services/sender.service';
import { SmsAdvCreateTabHandlerService } from '@services/sms-adv-create-tab-handler.service';
import { checkValidSmsAdvScheduleDate } from '@utils/validators';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { TabSmsAdv } from '../sms-adv-create.component';

@Component({
  selector: 'wsb-sms-adv-create-campaign',
  templateUrl: './sms-adv-create-campaign.component.html',
  styleUrls: ['./sms-adv-create-campaign.component.scss'],
  standalone: false
})
export class SmsAdvCreateCampaignComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('senderSettingModal') senderSettingModal;
  @ViewChild('smsAdvEditorView') smsAdvEditorView: SmsTextareaComponent;
  @ViewChild('noActiveLandingModal') noActiveLandingModal;

  @Input() smsAdvCampaignToSend: SmsAdv;
  @Output() enableProceedBtn: EventEmitter<boolean> = new EventEmitter<boolean>();

  senderSettingModalRef: NgbModalRef;
  sendSmsAdvCampaignForm: UntypedFormGroup;
  agcomSenders;

  tabSubscription: Subscription;

  // landing page
  isActiveLanding = false;
  showBtnAddPageLanding = false;
  idPage = null;
  noActiveLandingModalRef: NgbModalRef;

  // sending date
  minDate;
  maxDate;
  readonly SENDING_TYPE_SCHEDULED = 'SCHEDULED';
  sendDateFC = this.formBuilder.control('');
  timeFC = this.formBuilder.control('');
  timezone;
  public mask = {
    guide: true,
    showMask: true,
    // keepCharPositions : true,
    mask: [/[0-9]/, /\d/, ':', /\d/, /\d/]
  };

  constructor(
    private sendersService: SenderService,
    private formBuilder: UntypedFormBuilder,
    private translateService: TranslateService,
    private menuService: MenuService,
    // private atlasToast: AtlasToastService,
    private router: Router,
    private modalService: NgbModal,
    private pageService: PagesService,
    private tabHandlerService: SmsAdvCreateTabHandlerService,
    private cdRef: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    this.initSmsEditorView();
    this.cdRef.detectChanges();
  }

  ngOnInit(): void {
    this.callGetMenuEntriesState();
    this.verifyIfAtLeastOneActiveLanding();
    this.buildCreateSmsAdvCampaignForm();
    this.initFieldsForSendingDate();
    this.handlerTabClose();
    this.verifyToInitSendSmsAdvForm();
  }

  ngOnDestroy(): void {
    this.tabSubscription.unsubscribe();
  }

  setSenderForm(sender: SmsSender) {
    if (sender) {
      this.getIdSenderForm().setValue(sender.id);
      this.getValueSenderForm().setValue(sender.sender);
    } else {
      this.getSenderFG().reset();
    }
  }

  OpenSenderSettingModal() {
    this.senderSettingModalRef = this.modalService.open(this.senderSettingModal);
    this.senderSettingModalRef.result.then(
      result => {},
      reason => {
        this.closeSenderSettingModal();
      }
    );
  }

  routeToSenderSettingPage() {
    this.closeSenderSettingModal();
    return this.router.navigate(['sms/senders']);
  }

  openModalInsertTemplate() {
    const options: NgbModalOptions = {
      windowClass: 'custom-insert-modal-width'
    };
    const insertTemplateModal = this.modalService.open(InsertTemplateModalComponent, options);
    insertTemplateModal.componentInstance.isSmsAdv = true;
    insertTemplateModal.result.then(
      template => {
        this.sendSmsAdvCampaignForm.get('message').setValue(template.text);
        this.smsAdvEditorView.setValue(template.text, template.encoding);
      },
      () => {}
    );
  }

  btnSaveAsTemplate() {
    const options: NgbModalOptions = {
      size: 'lg'
    };
    const createTemplate = this.modalService.open(SmsTemplateCreateEditModalComponent, options);
    const template: SmsTemplate = {
      encoding: 'GSM',
      name: '',
      text: this.smsAdvEditorView.textControl.value
    } as SmsTemplate;
    (createTemplate.componentInstance as SmsTemplateCreateEditModalComponent).smsTemplate = template;
    (createTemplate.componentInstance as SmsTemplateCreateEditModalComponent).isSendSaveAsTemplate = true;
    (createTemplate.componentInstance as SmsTemplateCreateEditModalComponent).isSmsAdvTemplate = true;
  }

  btnAddLandingPage() {
    this.openLandingPageModal();
  }

  routeToLandingPage() {
    this.noActiveLandingModalRef.close();
    this.router.navigate(['/pages/list']);
  }

  get scheduledDate() {
    return this.sendSmsAdvCampaignForm.get('scheduledDate');
  }

  // private method
  private handlerTabClose() {
    this.tabSubscription = this.tabHandlerService.closeTab$.subscribe(tab => {
      if (tab === TabSmsAdv.TAB_CREATE_CAMPAIGN) {
        this.saveFormValue();
        return this.tabHandlerService.setTabIsCompleted(TabSmsAdv.TAB_CREATE_CAMPAIGN);
      }
    });
  }

  private saveFormValue() {
    const obs$ = this.tabHandlerService.valuesForm$(this.sendSmsAdvCampaignForm);
    this.tabHandlerService.saveTabFormData(obs$);
  }

  private initFieldsForSendingDate() {
    this.initDatePicker();
    this.setTimezone();
    this.sendDateFCValueChange();
    this.timeFCValueChange();
  }

  private sendDateFCValueChange() {
    this.sendDateFC.valueChanges.subscribe(sendDate => {
      const time = this.getTimeFC();
      if (sendDate && sendDate.length > 0 && time.length > 0) {
        this.setScheduleDate(sendDate, time);
      } else if (sendDate && sendDate.length > 0) {
      } else {
        this.resetScheduleDate();
      }
    });
  }

  private resetScheduleDate() {
    this.scheduledDate.reset();
  }

  private timeFCValueChange() {
    this.timeFC.valueChanges.subscribe(t => {
      const time = t.match('__:__') ? null : t;
      const sendDate = this.getSendDateFC();
      if (sendDate.length > 0 && time && time.length > 0) {
        this.setScheduleDate(sendDate, time);
      }
    });
  }

  private setScheduleDate(sendDate, time) {
    const scheduledDate = this.formatScheduledDate(sendDate, time);
    this.scheduledDate.setValue(scheduledDate);
  }

  private getSendDateFC() {
    return this.sendDateFC.value;
  }

  private getTimeFC() {
    const time = this.timeFC.value;
    if (time.match('__:__')) {
      return '';
    }
    return time;
  }

  private formatScheduledDate(date, time) {
    return date + 'T' + time + ':00' + this.timezone;
  }

  private setTimezone() {
    const today = new Date();
    const offset = moment(today).utcOffset();
    if (offset < 0) {
      this.timezone =
        '-' +
        today
          .toString()
          .split('-')[1]
          .split(' ')[0];
    } else {
      this.timezone =
        '+' +
        today
          .toString()
          .split('+')[1]
          .split(' ')[0];
    }
  }

  private initDatePicker() {
    const d = new Date();
    const year = d.getFullYear();
    const month = d.getMonth();
    const day = d.getDate();

    this.minDate = new Date(year, month, day + 2);
    this.maxDate = new Date(year + 2, month, day);

    // if we are between 23 dec and 31 dec we need to set mindate to 01 jan of next year, because we can't send sms in this range
    if (month === 11 && day >= 23) {
      this.minDate = new Date(year + 1, 0, 1);
    }
  }

  private openLandingPageModal() {
    if (this.isActiveLanding) {
      const options: NgbModalOptions = {
        windowClass: 'custom-insert-landing-modal-width'
      };
      const landingPageModal = this.modalService.open(LandingPageModalComponent, options);
      (landingPageModal.componentInstance as LandingPageModalComponent).link.subscribe(link => {
        if (this.smsAdvEditorView.textControl.value) {
          this.smsAdvEditorView.textControl.setValue(this.smsAdvEditorView.textControl.value + ' ' + link);
        } else {
          this.smsAdvEditorView.textControl.setValue(link);
        }
      });

      (landingPageModal.componentInstance as LandingPageModalComponent).idPage.subscribe(idPage => {
        this.idPage = idPage;
        this.sendSmsAdvCampaignForm.get('idPage').setValue(idPage);
      });
    } else {
      this.openNoActiveLandingModal();
    }
  }

  openNoActiveLandingModal(): void {
    this.noActiveLandingModalRef = this.modalService.open(this.noActiveLandingModal);
    this.noActiveLandingModalRef.result.then(
      result => {},
      reason => {
        this.noActiveLandingModalRef.close();
      }
    );
  }

  private verifyIfAtLeastOneActiveLanding() {
    const body = new ApiGetPageOptions();
    body.statuses = ['ONLINE'];
    this.pageService.getPages(0, null, null, null, body).subscribe(data => {
      if (data.data.length > 0) {
        this.isActiveLanding = true;
      }
    });
  }

  private initSmsEditorView() {
    this.smsAdvEditorView.textControl.valueChanges.subscribe(text => {
      this.sendSmsAdvCampaignForm.get('message').setValue(text);
    });
    if (this.smsAdvCampaignToSend) {
      this.verifyToInitMessageView(this.smsAdvCampaignToSend.message);
    }
  }

  private closeSenderSettingModal() {
    this.senderSettingModalRef.close();
  }
  private getSenderFG() {
    return this.sendSmsAdvCampaignForm.get('sender');
  }

  private getIdSenderForm() {
    return this.sendSmsAdvCampaignForm.get('sender').get('idSender');
  }

  private getValueSenderForm() {
    return this.sendSmsAdvCampaignForm.get('sender').get('valueSender');
  }

  private callGetMenuEntriesState() {
    this.menuService.getMenuEntriesState().subscribe(entries => {
      this.verifyIfShowBtnAddPageLanding(entries);
      this.setDropDownSender(entries);
    });
  }

  private verifyIfShowBtnAddPageLanding(entries) {
    if (entries && entries.pages) {
      this.showBtnAddPageLanding = true;
    }
  }

  private setDropDownSender(entries) {
    if (entries && entries[SMS_SENDERS]) {
      this.getAgcomSenders();
    }
  }

  private getAgcomSenders() {
    this.sendersService.getAllSendersNumericAndAlphaNumeric(false, 1, 200).subscribe(senders => {
      this.agcomSenders = senders;
    });
  }

  private buildCreateSmsAdvCampaignForm() {
    this.sendSmsAdvCampaignForm = this.formBuilder.group({
      idSmsAdvCampaign: [0],
      title: ['', [Validators.maxLength(64), Validators.required]],
      message: [, Validators.required],
      sender: this.formBuilder.group({
        idSender: [, Validators.required],
        valueSender: []
      }),
      sendingType: [this.SENDING_TYPE_SCHEDULED],
      scheduledDate: [, [Validators.required, checkValidSmsAdvScheduleDate()]],
      idPage: []
    });
    this.translateService.get('smsadv_send_default_title').subscribe(value => this.sendSmsAdvCampaignForm.get('title').setValue(value));
    this.sendSmsAdvCampaignFormChangeValue();
  }

  get senderFC() {
    return this.sendSmsAdvCampaignForm.get('sender');
  }

  private sendSmsAdvCampaignFormChangeValue() {
    this.sendSmsAdvCampaignForm.valueChanges.subscribe(() => {
      if (this.sendSmsAdvCampaignForm.valid) {
        return this.enableProceedBtn.emit(true);
      }
      this.enableProceedBtn.emit(false);
    });
  }

  private verifyToInitSendSmsAdvForm() {
    if (this.smsAdvCampaignToSend) {
      this.sendSmsAdvCampaignForm.patchValue(this.smsAdvCampaignToSend);
      this.initScheduledDateFC(this.smsAdvCampaignToSend.scheduledDate);
    }
  }

  private verifyToInitMessageView(message) {
    if (message) {
      this.smsAdvEditorView.textControl.setValue(message);
    }
  }

  private initScheduledDateFC(date: string) {
    if (date) {
      const scheduledDate = this.getFormatDateAndTime(date);
      this.sendDateFC.setValue(scheduledDate.date);
      this.timeFC.setValue(scheduledDate.time);
    }
  }

  private getFormatDateAndTime(scheduledDate) {
    const dateTime = this.formatScheduleDate(scheduledDate).split(' ');
    const date = dateTime[0];
    const time = dateTime[2] ? dateTime[1] + ' ' + dateTime[2] : dateTime[1];
    return { date, time };
  }

  private formatScheduleDate(date) {
    const formatDate = 'YYYY-MM-DD';
    const formatTime = 'HH:mm';
    return moment(date).format(formatDate + (true ? ' ' + formatTime : ''));
  }
}
